import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static override targets = ["flash"]

  declare readonly flashTarget: HTMLElement

  override connect() {
    // Automatically remove flash messages after 5 seconds
    setTimeout(() => {
      this.remove()
    }, 5000)
  }

  remove() {
    this.flashTarget.remove()
  }
}
